var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"route":_vm.$route}},[_c('template',{slot:"action-button"},[_c('ActionButton',{attrs:{"id":"refresh","icon":"fa-sync-alt"}})],1)],2),_c('PageRowWrapper',[_c('div',{staticClass:"col-sm-12"},[_c('ArenaVehicles2001')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }